import { useEffect, useState } from 'react';
import { servGetAllInstrumentos } from '../../servicos/instrumento';

function SelectInstrumento({ setInstrumento }) {

    const [instrumentos, setInstrumentos] = useState([])

    useEffect(() => {
        getAllInstrumento()
    }, []);

    const getAllInstrumento = async () => {
        try {
            const instrumentosDaApi = await servGetAllInstrumentos()
            setInstrumentos(instrumentosDaApi.data);
        } catch (erro) {
            console.log(erro);
        }
    }

    const handleChange = (event) => {
        setInstrumento(event.target.value)
    };

    return (
        <>
            {instrumentos ? (
                <div className="d-flex gap-1 align-items-center">
                    <select
                        className="form-select form-select-sm"
                        id="instrumento"
                        defaultValue=""
                        onChange={handleChange}
                        required
                    >
                        {instrumentos.map((instrumento) => (
                            <option key={instrumento.id} value={instrumento.id}>
                                {instrumento.numero}
                            </option>
                        ))}
                    </select>
                </div>
            ) : (
                <p>Carregando...</p>
            )}
        </>
    )
}

export default SelectInstrumento